import { eksmoBP } from 'Lib/bp/bp';
import { Calendar } from '@fullcalendar/core';
import ruLocale from '@fullcalendar/core/locales/ru';
import dayGridPlugin from '@fullcalendar/daygrid';
import momentPlugin from '@fullcalendar/moment';
import moment from 'moment';
import { getW } from 'Lib/w/w';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';

const $calendar = $('.calendar');
let isOpen = false;
const href = $calendar.attr('data-href');
const hrefLink = $calendar.attr('data-href-link');
const sDay = '.fc-day-top';

if (isNoEmptyString(href) && isNoEmptyString(hrefLink)) {
    const $content = $('.calendar__content');
    const calendar = new Calendar($content[0], {
        plugins: [dayGridPlugin, momentPlugin],
        locale: ruLocale,
        // old
        // firstHour: 9,
        // axisFormat: 'H:mm',
        // timeFormat: {
        //     agenda: 'H:mm'
        // },
        header: {
            left: 'prev',
            center: 'title',
            right: 'next',
        },
        firstDay: 1,
        editable: false,
        height: 'auto',
        handleWindowResize: true,
        eventLimit: true, // allow "more" link when too many events
        events: {
            url: href,
            error() {

            },
        },
        eventRender(info) {
            $calendar.find(`${sDay}[data-date="${moment(info.event.start).format('YYYY-MM-DD')}"]>.fc-day-number`).css({ 'background-color': info.event.backgroundColor, 'color': info.event.textColor });
        },
    });

    calendar.render();

    const $calendarHeight = $content.height(); // Установка высоты календаря для анимации

    $calendar.on('click', sDay, function () {
        const date = $(this).attr('data-date');

        if (isNoEmptyString(date)) {
            document.location = `${hrefLink + date}/`;
        }
    });

    // раскрытие/скрытие календаря
    if (getW() > eksmoBP.smMax) {
        isOpen = true;
        $calendar.removeClass('calendar_close');
    }

    $calendar.on('click', () => {
        if (getW() <= eksmoBP.smMax) {
            if (isOpen === false) {
                $calendar.outerHeight($calendarHeight);
                $calendar.removeClass('calendar_close');
                isOpen = true;
            }
        }
    });

    $('.calendar__close-button').on('click', (event) => {
        if (getW() <= eksmoBP.smMax) {
            if (isOpen === true) {
                $calendar.outerHeight(44);
                $calendar.addClass('calendar_close');
                isOpen = false;
                event.stopPropagation();
            }
        }
    });

    $('body').on('eksmoResizeWidth', (e, newW) => {
        if (newW > eksmoBP.smMax) {
            $calendar.removeClass('calendar_close');
            $calendar.css('height', '');
            isOpen = true;
        }
    });
    // end раскрытие/скрытие календаря
}